"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarBadge = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Badge = require("../../../shared/Badge");
const AvatarBadge = (0, _styled.default)(_Badge.Badge)`
    ${_ref => {
  let {
    size
  } = _ref;
  return `
    bottom: -5px;
    right: -5px;
    border-radius: 100%;
    padding: 0px;
    border-width: 2px;
    span:has(svg) {
        width: ${size}px;
        height: ${size}px;
    }
    ${size === 18 ? `
        bottom: -7px;
        right: -7px;
    ` : ``}
    `;
}}
`;
exports.AvatarBadge = AvatarBadge;
//# sourceMappingURL=AvatarBadge.js.map